import { SxProps, Theme } from '@mui/material'

export const styles: Record<string, SxProps<Theme>> = {
  '.torque-test-report': {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
  },
  '.implant-number-input-with-button': {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    width: '100%',
  },
  '.implant-number-input-array': {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
  },
  '.add-icon': {
    color: '#1976d2',
  },
}
